<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    title-text="Изменение статуса пользователей"
    success-text="Статус изменен"
    error-text="Ошибка изменния статуса"
    cancel-btn="Отменить"
    success-btn="Изменить"
    :action="onAction"
    @closed="$emit('closed')"
  >
    <v-row dense align="center">
      <v-col cols="auto">
        <v-switch
          v-model="form.is_active"
          dense
          class="my-0 ml-2"
          hide-details
          name="is_active"
        />
      </v-col>

      <v-col cols="auto">
        <v-fade-transition leave-absolute>
          <span
            :key="activeLabel"
            class="subtitle-1"
            :class="{ 'success--text': form.is_active, 'error--text': !form.is_active }"
            v-text="activeLabel"
          />
        </v-fade-transition>
      </v-col>
    </v-row>
  </BModalConfirm>
</template>

<script>
import { UserModel as Model } from '../Model'

import BModalConfirm from '@/components/modals/BModalConfirm.vue'


const createDefaultData = () => ({
  is_active: true,
})

export default {
  name: 'UsersModalChangeStatus',
  components: {
    BModalConfirm,
  },
  inheritAttrs: false,
  props: {
    users: {
      type: Array,
      required: true,
    },
    action: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    form: createDefaultData(),
  }),
  computed: {
    activeLabel() {
      return Model.getUserStatusLabel(this.form)
    },
  },
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    onAction() {
      const userIds = this.users.map((_) => _.id)
      const payload = { user_ids: userIds, is_active: this.form.is_active }
      return this.action({ payload })
    },
  },
}
</script>
